import { getCellDataValue } from "./types/CellValue";
/**
 * Gets all the result matches for the refiner option.
 */
function getMatchesForRefinerOption(refinerGroup, refinerOption, results) {
    return results.filter((result) => {
        return isMatch(refinerOption, refinerGroup, result);
    });
}
/**
 * Does the result match the refiner option.
 */
function isMatch(refinerOption, refinerGroup, result) {
    return (typeof result[refinerGroup.path] === "boolean" && refinerOption.value === getCellDataValue(result[refinerGroup.path]) ||
        result[refinerGroup.path] === refinerOption.value ||
        (refinerOption.value === "-" && (result[refinerGroup.path] === undefined || result[refinerGroup.path] === null || new String(result[refinerGroup.path]).trim() === "")));
}
/**
 * Updates refiner based on list matches
 */
export const updateListRefiner = ({ group, results }) => {
    let newFilteredResults = null;
    group.refinerOptions.forEach((o) => {
        const matches = getMatchesForRefinerOption(group, o, results);
        o.count = matches.length;
        if (o.isSelected) {
            if (newFilteredResults === null) {
                newFilteredResults = [];
            }
            newFilteredResults.push(...matches);
        }
    });
    return newFilteredResults;
};
/**
 * Populates the refiner options for a set of results based on pre-defined refiner groups that can be used.
 * @param refinerGroups The refiner groups to populate the options for.
 * @param results The results to create refiner options for.
 */
export function createRefinerOptions(refinerGroups, data) {
    data.forEach((r) => {
        refinerGroups.forEach((group) => {
            const value = getCellDataValue(r[group.path]);
            const option = group.refinerOptions.find((o) => o.value === value);
            if (value !== undefined) {
                if (option) {
                    option.count++;
                }
                else {
                    if (group.secondaryTextMapping && group.secondaryTextMapping[value.toString()]) {
                        group.refinerOptions.push({
                            count: 1,
                            isSelected: false,
                            value: value,
                            secondaryText: group.secondaryTextMapping[value.toString()]
                        });
                    }
                    else {
                        group.refinerOptions.push({
                            count: 1,
                            isSelected: false,
                            value: value,
                        });
                    }
                }
            }
        });
    });
}
/**
 *
 */
export function isRefinerGroupEmpty(refinerGroup) {
    return refinerGroup.refinerOptions.every((o) => o.count === 0);
}
